import { createActions, createReducer } from "reduxsauce";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
};

export const { Types, Creators } = createActions({
  setQuoteAnalyzed: ["quoteAnalyzed"]
});

const INITIAL_STATE: {
  quoteAnalyzed: boolean;
} = {
  quoteAnalyzed: false
};

const setQuoteAnalyzed = (state = INITIAL_STATE, action: any) => ({
  ...state,
  quoteAnalyzed: true,
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_QUOTE_ANALYZED as any]: setQuoteAnalyzed
});
